import { clsx } from 'clsx';
import { Bookmark } from '@hungryroot/icons';
import {
  IconButton,
  type IconButtonProminenceVariant,
  type IconButtonSizeVariant,
  type IconButtonStyleVariant,
} from '@hungryroot/ramen';
import styles from './BookmarkButton.module.css';

interface BookmarkButtonProps {
  onClick: () => void;
  className?: string;
  isBookmarked: boolean;
  size?: IconButtonSizeVariant;
  style?: IconButtonStyleVariant;
  prominence?: IconButtonProminenceVariant;
}

export function BookmarkButton(props: BookmarkButtonProps) {
  const {
    onClick,
    className,
    isBookmarked,
    size = 'small',
    style = 'inverted',
    prominence = 'primary',
  } = props;

  const selectedClass = clsx({
    [styles.default]: !isBookmarked,
    [styles.active]: isBookmarked,
  });

  return (
    <IconButton
      icon={<Bookmark />}
      size={size}
      style={style}
      prominence={prominence}
      ariaLabel={isBookmarked ? 'Remove bookmark' : 'Bookmark'}
      onClick={onClick}
      className={`${className} ${selectedClass}`}
    />
  );
}
